export default {"src":"/_next/static/media/swap-orange.a0a1fab2.svg","height":21,"width":19,"blurWidth":0,"blurHeight":0};